/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { Button } from "@mui/material";

const DocumentArchiveDialogActions = (props) => {
    
    const {
        handleArchive,
        handleCancel,
        loading
    } = props;

    return (
        <Fragment>
            <div className="simplicity-document-selector-window-footer">
                
                {!loading &&
                    <Button
                        variant='contained'
                        color='primary'
                        onClick={handleArchive}
                    >
                        Archive
                    </Button>
                }
                
                <Button
                    variant='outlined'
                    color='secondary'
                    onClick={handleCancel}
                >
                    Cancel
                </Button>
                
            </div>
        </Fragment>
    );
};

export { DocumentArchiveDialogActions };
